import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import RegistrationPage from './components/RegistrationPage';
import SavedProfilesPage from './components/SavedProfilesPage';
import SavedLeadsPage from './components/SavedLeadsPage';
import HomePage from './components/HomePage';
import HomeTable from './components/HomeTable';
import LeadList from './components/LeadList';
import LeadDetails from './components/LeadDetails';
import Header from './components/Header';
import LoggedInLayout from './components/LoggedInLayout';
import LayoutNoHeader from './components/LayoutNoHeader';
import LayoutWithHeader from './components/LayoutWithHeader';

function App() {
  return (
    <Router>
      <Routes>
        {/* Routes that do NOT have a header */}
          <Route element={<LayoutNoHeader />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          {/* Add more “no-header” routes here */}
        </Route>
        {/* Routes that have a header */}
        <Route element={<LayoutWithHeader />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<HomeTable />} />
          <Route path="dashboard/:id" element={<LeadDetails />} />
          <Route path="/dashboard-legacy" element={<LeadList />} />
          <Route path="saved-profiles" element={<SavedProfilesPage /> } />
          <Route path="saved-leads" element={<SavedLeadsPage /> } />
          {/* Add more “with-header” routes here */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;

